import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Customer} from './customer.model'
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CustomerService {
selectedCustomer: Customer = {
  userName : '',
  password : '',
  fullName : '',
  companyName : '',
  country : '',
  licenseCode : '',
  mailingAddress : '',
  contactNumber : '',
  email : '',

  gstNumber : '',
  PAN : '',
  currency : '',
  bankName : '',
  bankAccountNumber : '',
  IFSC : '',
  SWIFT : '',
  role : ''
};

balanceEmitter = new Subject<any>();
noAuthHeader = { headers: new HttpHeaders({ 'NoAuth': 'True' }) };
constructor(private http: HttpClient) { }

  postCustomer(customer: Customer){
    ////console.log('Inside post customer', customer);
    return this.http.post(environment.apiBaseUrl+ '/moderator/signup', customer);
  }

  getCurrentBalance(){
    console.log("OK");
    return this.http.get(environment.apiBaseUrl + '/customer/get-current-credit-balance')
  }

  getTransactions(){
    return this.http.get(environment.apiBaseUrl+'/customer/get-transactions')
  }

  debitPerTransaction(curveId){
    return this.http.post(environment.apiBaseUrl+'/customer/debit-per-transaction', curveId)
  }

  getAllStandardAlloys(){
    return this.http.get(environment.apiBaseUrl + '/customer/get-all-standard-alloy')
  }

  getStandardAlloy(){
    return this.http.get(environment.apiBaseUrl + '/customer/get-standard-alloy')
  }

  replyToTicket(ticketDetails,fileToUpload){
    console.log(fileToUpload)
    const formData =new FormData()
    ticketDetails.uploaderId="papa";
    formData.append('data',JSON.stringify(ticketDetails))

    if(fileToUpload)
      formData.append('file',fileToUpload)

    formData.forEach((value,key) => {
      console.log(key+" "+value)
    });

    const req = this.http.post(environment.apiBaseUrl+`/customer/reply-to-ticket`, formData);
    console.log(req)
    return req;
  }

  getPaymentInfo(){
    return this.http.post(environment.apiBaseUrl + '/customer/get-payment-info', {})
  }


  async sendInvoice(customerID){
    let x = {
      customerId: customerID
    }
    return await fetch(environment.apiBaseUrl+ '/moderator/send-invoice', {
      method: 'POST',
      body: JSON.stringify(x),
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    })
  }

  async sendInvoiceDateFilter(customerID, startDate, endDate){
    try {
        let x = {
          customerId: customerID,
          startDate: startDate,
          endDate: endDate
        }
        let returnedBody = await fetch(environment.apiBaseUrl + '/moderator/send-invoice-date-filter', {
          method: 'POST',
          body: JSON.stringify(x),
          headers: {
            'Content-type': 'application/json; charset=UTF-8'
          }
        });
       //console.log(returnedBody);

        return returnedBody;
    } catch (err) {
     //console.log('error', err)
    }
    }
}
